import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Validators } from 'angular-reactive-validation';

import { Hub } from '@qwyk/models';

import { CreateMagayaNetworkConfigurationPayload } from './../../+state/magaya-network-configuration.models';

@Component({
    selector: 'qwyk-magaya-network-create',
    templateUrl: './magaya-network-create.component.html',
    styleUrls: ['./magaya-network-create.component.scss'],
})
export class MagayaNetworkCreateComponent {
    public form: FormGroup;
    @Output()
    public create: EventEmitter<CreateMagayaNetworkConfigurationPayload> = new EventEmitter<CreateMagayaNetworkConfigurationPayload>();

    @Input()
    public organization: Hub.Organization;

    @Input()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public error: any;

    private _loading: boolean;
    get loading(): boolean {
        return this._loading;
    }

    @Input()
    set loading(value: boolean) {
        this._loading = value;
        if (value) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    public get iconAnimation(): 'pulse' | undefined {
        return this.loading ? 'pulse' : undefined;
    }

    constructor(private fb: FormBuilder, private translate: TranslateService) {
        this.form = fb.group({
            network_id: [
                null,
                [
                    Validators.required(
                        this.translate.instant(
                            'hub.console.organizations.field-is-required',
                            {
                                value: this.translate
                                    .instant(
                                        'hub.console.organizations.network-id'
                                    )
                                    .toLowerCase(),
                            }
                        )
                    ),
                ],
            ],
            superuser_username: [
                null,
                [
                    Validators.required(
                        this.translate.instant(
                            'hub.console.organizations.field-is-required',
                            {
                                value: this.translate
                                    .instant(
                                        'hub.console.organizations.superuser-username'
                                    )
                                    .toLowerCase(),
                            }
                        )
                    ),
                    Validators.maxLength(50, maxLength =>
                        this.translate.instant(
                            'hub.console.organizations.field-may-not-be-more-than-x-chars-long',
                            {
                                field: this.translate
                                    .instant(
                                        'hub.console.organizations.superuser-username'
                                    )
                                    .toLowerCase(),
                                maxLength,
                            }
                        )
                    ),
                ],
            ],
            superuser_password: [
                null,
                [
                    Validators.required(
                        this.translate.instant(
                            'hub.console.organizations.field-is-required',
                            {
                                value: this.translate
                                    .instant(
                                        'hub.console.organizations.superuser-password'
                                    )
                                    .toLowerCase(),
                            }
                        )
                    ),
                    Validators.maxLength(50, maxLength =>
                        this.translate.instant(
                            'hub.console.organizations.field-may-not-be-more-than-x-chars-long',
                            {
                                field: this.translate
                                    .instant(
                                        'hub.console.organizations.superuser-password'
                                    )
                                    .toLowerCase(),
                                maxLength,
                            }
                        )
                    ),
                ],
            ],
        });
    }

    public onSubmit(): void {
        this.form.markAllAsTouched();
        if (this.form.invalid) {
            return;
        }
        this.create.emit({
            ...this.form.value,
            organization_id: this.organization.id,
        } as CreateMagayaNetworkConfigurationPayload);
    }

    public onReset(): void {
        this.form.reset();
    }
}
